// source: pbtypes/vehicle/infrastructure/flight_deck/runmode.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.flight_deck.RunMode', null, global);
goog.exportSymbol('proto.flight_deck.RunModeAction', null, global);
goog.exportSymbol('proto.flight_deck.RunModeRequest', null, global);
goog.exportSymbol('proto.flight_deck.RunModeStatus', null, global);
goog.exportSymbol('proto.flight_deck.RunmodeRequestError', null, global);
goog.exportSymbol('proto.flight_deck.RunmodeRequestError.ErrorCode', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.RunModeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.RunModeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.RunModeRequest.displayName = 'proto.flight_deck.RunModeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.RunMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.RunMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.RunMode.displayName = 'proto.flight_deck.RunMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.RunmodeRequestError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.RunmodeRequestError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.RunmodeRequestError.displayName = 'proto.flight_deck.RunmodeRequestError';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.RunModeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.RunModeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.RunModeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunModeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
runModeName: jspb.Message.getFieldWithDefault(msg, 1, ""),
action: jspb.Message.getFieldWithDefault(msg, 2, 0),
runModeArgsMap: (f = msg.getRunModeArgsMap()) ? f.toObject(includeInstance, undefined) : [],
utime: jspb.Message.getFieldWithDefault(msg, 4, 0),
requestId: jspb.Message.getFieldWithDefault(msg, 5, 0),
synchronizeQcu: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.RunModeRequest}
 */
proto.flight_deck.RunModeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.RunModeRequest;
  return proto.flight_deck.RunModeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.RunModeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.RunModeRequest}
 */
proto.flight_deck.RunModeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRunModeName(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_deck.RunModeAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 3:
      var value = msg.getRunModeArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readStringRequireUtf8, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSynchronizeQcu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.RunModeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.RunModeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.RunModeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunModeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRunModeName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRunModeArgsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getRunModeArgsMap(true),
    3,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSynchronizeQcu();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string run_mode_name = 1;
 * @return {string}
 */
proto.flight_deck.RunModeRequest.prototype.getRunModeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.setRunModeName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RunModeAction action = 2;
 * @return {!proto.flight_deck.RunModeAction}
 */
proto.flight_deck.RunModeRequest.prototype.getAction = function() {
  return /** @type {!proto.flight_deck.RunModeAction} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_deck.RunModeAction} value
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * map<string, string> run_mode_args = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.flight_deck.RunModeRequest.prototype.getRunModeArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.clearRunModeArgsMap = function() {
  this.getRunModeArgsMap().clear();
  return this;
};


/**
 * optional int64 utime = 4;
 * @return {number}
 */
proto.flight_deck.RunModeRequest.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 request_id = 5;
 * @return {number}
 */
proto.flight_deck.RunModeRequest.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool synchronize_qcu = 6;
 * @return {boolean}
 */
proto.flight_deck.RunModeRequest.prototype.getSynchronizeQcu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.RunModeRequest} returns this
 */
proto.flight_deck.RunModeRequest.prototype.setSynchronizeQcu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.RunMode.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.RunMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.RunMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunMode.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
utime: jspb.Message.getFieldWithDefault(msg, 3, 0),
requestId: jspb.Message.getFieldWithDefault(msg, 4, 0),
actionTaken: jspb.Message.getFieldWithDefault(msg, 5, 0),
error: (f = msg.getError()) && proto.flight_deck.RunmodeRequestError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.RunMode}
 */
proto.flight_deck.RunMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.RunMode;
  return proto.flight_deck.RunMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.RunMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.RunMode}
 */
proto.flight_deck.RunMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_deck.RunModeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestId(value);
      break;
    case 5:
      var value = /** @type {!proto.flight_deck.RunModeAction} */ (reader.readEnum());
      msg.setActionTaken(value);
      break;
    case 6:
      var value = new proto.flight_deck.RunmodeRequestError;
      reader.readMessage(value,proto.flight_deck.RunmodeRequestError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.RunMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.RunMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.RunMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getActionTaken();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.flight_deck.RunmodeRequestError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.flight_deck.RunMode.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RunModeStatus status = 2;
 * @return {!proto.flight_deck.RunModeStatus}
 */
proto.flight_deck.RunMode.prototype.getStatus = function() {
  return /** @type {!proto.flight_deck.RunModeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_deck.RunModeStatus} value
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 utime = 3;
 * @return {number}
 */
proto.flight_deck.RunMode.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 request_id = 4;
 * @return {number}
 */
proto.flight_deck.RunMode.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional RunModeAction action_taken = 5;
 * @return {!proto.flight_deck.RunModeAction}
 */
proto.flight_deck.RunMode.prototype.getActionTaken = function() {
  return /** @type {!proto.flight_deck.RunModeAction} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.flight_deck.RunModeAction} value
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.setActionTaken = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional RunmodeRequestError error = 6;
 * @return {?proto.flight_deck.RunmodeRequestError}
 */
proto.flight_deck.RunMode.prototype.getError = function() {
  return /** @type{?proto.flight_deck.RunmodeRequestError} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.RunmodeRequestError, 6));
};


/**
 * @param {?proto.flight_deck.RunmodeRequestError|undefined} value
 * @return {!proto.flight_deck.RunMode} returns this
*/
proto.flight_deck.RunMode.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.RunMode} returns this
 */
proto.flight_deck.RunMode.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.RunMode.prototype.hasError = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.RunmodeRequestError.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.RunmodeRequestError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.RunmodeRequestError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunmodeRequestError.toObject = function(includeInstance, msg) {
  var f, obj = {
errorCode: jspb.Message.getFieldWithDefault(msg, 1, 0),
errorMessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.RunmodeRequestError}
 */
proto.flight_deck.RunmodeRequestError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.RunmodeRequestError;
  return proto.flight_deck.RunmodeRequestError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.RunmodeRequestError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.RunmodeRequestError}
 */
proto.flight_deck.RunmodeRequestError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_deck.RunmodeRequestError.ErrorCode} */ (reader.readEnum());
      msg.setErrorCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.RunmodeRequestError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.RunmodeRequestError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.RunmodeRequestError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.RunmodeRequestError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.RunmodeRequestError.ErrorCode = {
  SUCCESS: 0,
  INVALID_USAGE: 1,
  UNKNOWN_ERROR: 2
};

/**
 * optional ErrorCode error_code = 1;
 * @return {!proto.flight_deck.RunmodeRequestError.ErrorCode}
 */
proto.flight_deck.RunmodeRequestError.prototype.getErrorCode = function() {
  return /** @type {!proto.flight_deck.RunmodeRequestError.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_deck.RunmodeRequestError.ErrorCode} value
 * @return {!proto.flight_deck.RunmodeRequestError} returns this
 */
proto.flight_deck.RunmodeRequestError.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.flight_deck.RunmodeRequestError.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.RunmodeRequestError} returns this
 */
proto.flight_deck.RunmodeRequestError.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.flight_deck.RunModeStatus = {
  STOPPED_OK: 0,
  STOPPED_ERROR: 1,
  RUNNING_OK: 2,
  RUNNING_ERROR: 3
};

/**
 * @enum {number}
 */
proto.flight_deck.RunModeAction = {
  NONE: 0,
  START: 1,
  TERMINATE: 2,
  TERMINATE_AND_START: 3,
  SET_DEFAULT: 4
};

goog.object.extend(exports, proto.flight_deck);
